import { TablePagination } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { FC, Fragment } from 'react';

interface Props {
  hidePagination: boolean;
  length: number;
  page?: number;
  rowsPerPage?: number;
  setPage?: (page: number) => void;
  setRowsPerPage?: (rowsPerPage: number) => void;
  renderHeader(): React.ReactNode;
  renderRows(): React.ReactNode;
  useCardStyles?: boolean;
}

// export const StyledTableRow = () => {
//   return <TableRow  />;
// };

export const LaunchpadTable: FC<Props> = ({
  hidePagination,
  length,
  page,
  rowsPerPage,
  renderHeader,
  renderRows,
  setPage,
  setRowsPerPage,
  useCardStyles = true,
}) => {
  return (
    <>
      <TableContainer component={useCardStyles ? Paper : Fragment}>
        <Table
          style={{
            borderCollapse: 'separate',
          }}
        >
          <TableHead>{renderHeader()}</TableHead>
          <TableBody>{renderRows()}</TableBody>
        </Table>
      </TableContainer>
      {!hidePagination && setPage && setRowsPerPage && rowsPerPage ? (
        <TablePagination
          rowsPerPageOptions={[5, 15, 25, 50]}
          component="div"
          count={length}
          rowsPerPage={rowsPerPage}
          page={page ?? 0}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(event.target.value as any as number);
          }}
          onPageChange={(event, newPage) => {
            setPage(newPage);
          }}
        />
      ) : null}
    </>
  );
};
